var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-name": "Layer 1",
    viewBox: "0 0 314.3 350",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f8ed44;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.33 226.38-134.74-220.68a11.86 11.86 0 0 0-14.08-5l138.29 226.47a12.38 12.38 0 0 1 0.57 11.86l-27.29 56.36a12.45 12.45 0 0 1-1.94 2.9 11.86 11.86 0 0 0 13.52-6.37l26.22-54.14a11.91 11.91 0 0 0-0.55-11.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.82 265.75 209.48 259.48 225 285.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.48 186.02 35.95 215.78 98.03 81.03 145.87 158.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.01 291.6 30.17-65.48 132.21-40.39 41.3 66.37-190.95 54.39a10.76 10.76 0 0 1-12.73-14.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m288.38 239.07-26.32 54.33a12 12 0 0 1-20.9 1.13l-139.09-222.27 29.42-64.85a12 12 0 0 1 21.09-1.29l135.24 221.5a12 12 0 0 1 0.56 11.45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m288.38 239.07-26.32 54.33a12 12 0 0 1-20.9 1.13l-139.09-222.27 29.42-64.85a12 12 0 0 1 21.09-1.29l135.24 221.5a12 12 0 0 1 0.56 11.45z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d855de8e71fc66d1064465058ec96119.svg";
export { ForwardRef as ReactComponent };